/* eslint-disable no-nested-ternary */
/* eslint-disable object-shorthand */
/* eslint-disable no-shadow */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import { Box, IconButton } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import CloseIcon from "@mui/icons-material/Close";
import * as Sentry from "@sentry/react";
import { Formik } from "formik";
import { useSelector } from "react-redux";
import Button from "../../../../components/common/Button";
import Typography from "../../../../components/common/new/Typography/Typography";
import { CommonStyles } from "../../../../components/common/Button/commonButtonStyle";
import Member from "../../../../services/api/member";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../../contants";
import AutoCompleteDropdown from "../../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import IntroductionFormApi from "../../../../services/api/introductionForm";
// import InputField from "../../../../components/common/new/InputField/InputField";
import { selectAllSIUsers } from "../../../../redux/selectors/user";
import style from "./HDCModal.style";
import Loader from "../../../../components/common/Loader/Loader";
import { getOptions } from "../../../../utils";

const MEMBER_HDC_CREATE = {
  AREA: "areaId",
  ZONE: "zoneId",
  REGION: "regionId",
  CHAPTER: "chapterId",
  DISTRICT: "districtId",
};
const MEMBER_HDC_CREATE_SECOND = {
  AREA: "areaIdSecond",
  ZONE: "zoneIdSecond",
  REGION: "regionIdSecond",
  CHAPTER: "chapterIdSecond",
  DISTRICT: "districtIdSecond",
};

function HDCModal({ selectedMember, onClose }) {
  //   const { roles, chapterId, proxyRoles } = selectedMember;
  const {
    areaId,
    zoneId,
    regionId,
    chapterId,
    // districtId,
    // blockId,
    memberId,
    fullName,
  } = selectedMember;
  const data = selectedMember;
  const [area, setArea] = useState([]);
  const [zone, setZone] = useState([]);
  const [region, setRegion] = useState([]);
  const [chapter, setChapter] = useState([]);
  const [district, setDistrict] = useState([]);
  const toast = useContext(ToastAlertContext);
  const [secondZone, setSecondZone] = useState([]);
  const [secondRegion, setSecondRegion] = useState([]);
  const [secondChapter, setSecondChapter] = useState([]);
  const [secondDistrict, setSecondDistrict] = useState([]);
  const [hdcData, setHdcData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSecond, setIsLoadingSecond] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)");

  const { isHelpDesk, isAreaSi, isZoneSi, isHelpDeskAdmin } =
    useSelector(selectAllSIUsers);

  const mainlinePosition = selectedMember?.positions?.find(
    (position) => position?.positionType === "MAINLINE_POSITION"
  )?.name;

  const nationalHDC = selectedMember?.positions?.some((position) => {
    const allowedPositionNames = [72, 71, 63, 58];
    // return allowedPositionNames.includes(position.name);
    return (
      allowedPositionNames.includes(position.id) &&
      position.positionType === "MAINLINE_POSITION"
    );
  });

  const areaHDC = selectedMember?.positions?.some((position) => {
    const allowedPositionNames = [62, 61];
    // return allowedPositionNames.includes(position.name);
    return (
      allowedPositionNames.includes(position.id) &&
      position.positionType === "MAINLINE_POSITION"
    );
  });

  const zoneHDC = selectedMember?.positions?.some((position) => {
    const allowedPositionNames = [59, 51];
    // return allowedPositionNames.includes(position.name);
    return (
      allowedPositionNames.includes(position.id) &&
      position.positionType === "MAINLINE_POSITION"
    );
  });

  const regionHDC = selectedMember?.positions?.some((position) => {
    const allowedPositionNames = [28, 27];
    // return allowedPositionNames.includes(position.name);
    return (
      allowedPositionNames.includes(position.id) &&
      position.positionType === "MAINLINE_POSITION"
    );
  });

  const Areas = async () => {
    if (areaId) {
      const response = await IntroductionFormApi.getAllArea({
        areaId,
      });
      setArea(response.data);
    }
  };

  const getFetchData = async (selectedMember) => {
    try {
      const response = await Member.getHdcByMemberId({
        memberId: selectedMember?.memberId,
      });
      setHdcData(response.data);
      console.log("hdcData 135", hdcData);
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const NewZones = async () => {
    setIsLoading(true);
    if (hdcData?.hdcApplications?.[0]?.areaId) {
      const response = await IntroductionFormApi.getZones({
        areaId: hdcData?.hdcApplications?.[0]?.areaId,
      });
      setZone(response.data);
    }
  };

  const SecondNewZones = async () => {
    setIsLoading(true);
    if (hdcData?.hdcApplications?.[1]?.areaId) {
      const response = await IntroductionFormApi.getZones({
        areaId: hdcData?.hdcApplications?.[1]?.areaId,
      });
      setSecondZone(response.data);
    }
  };

  const NewRegions = async () => {
    setIsLoading(true);
    if (hdcData?.hdcApplications?.[0]?.zoneId) {
      const response = await IntroductionFormApi.getRegions({
        zoneId: hdcData?.hdcApplications?.[0]?.zoneId,
      });
      setRegion(response.data);
    }
  };

  const SecondNewRegions = async () => {
    setIsLoading(true);
    if (hdcData?.hdcApplications?.[1]?.zoneId) {
      const response = await IntroductionFormApi.getRegions({
        zoneId: hdcData?.hdcApplications?.[1]?.zoneId,
      });
      setSecondRegion(response.data);
    }
  };

  const NewChapters = async () => {
    setIsLoading(true);
    if (hdcData?.hdcApplications?.[0]?.regionId) {
      const response = await IntroductionFormApi.getChapters({
        regionId: hdcData?.hdcApplications?.[0]?.regionId,
      });
      setChapter(response.data);
    }
  };

  const SeondNewChapters = async () => {
    setIsLoading(true);
    if (hdcData?.hdcApplications?.[1]?.regionId) {
      const response = await IntroductionFormApi.getChapters({
        regionId: hdcData?.hdcApplications?.[1]?.regionId,
      });
      setSecondChapter(response.data);
    }
  };

  const NewDistricts = async () => {
    setIsLoading(true);

    if (hdcData?.hdcApplications?.[0]?.regionId) {
      const response = await IntroductionFormApi.getDistricts({
        chapterId: hdcData?.hdcApplications?.[0]?.chapterId,
      });
      setDistrict(response.data);
    }
  };

  const SecondNewDistricts = async () => {
    setIsLoading(true);

    if (hdcData?.hdcApplications?.[1]?.regionId) {
      const response = await IntroductionFormApi.getDistricts({
        chapterId: hdcData?.hdcApplications?.[1]?.chapterId,
      });
      setSecondDistrict(response.data);
    }
  };

  const Zones =
    (isHelpDesk || isHelpDeskAdmin) && areaHDC
      ? async () => {
          if (areaId) {
            const response = await IntroductionFormApi.getZones({
              areaId,
            });
            setZone(response.data);
          }
        }
      : (isAreaSi && zoneHDC) ||
        (isHelpDesk && zoneHDC) ||
        (isHelpDeskAdmin && zoneHDC)
      ? async () => {
          if (areaId) {
            const response = await IntroductionFormApi.getZones({
              areaId,
            });
            setZone(response.data);
          }
        }
      : (isZoneSi && regionHDC) ||
        (isHelpDesk && regionHDC) ||
        (isHelpDeskAdmin && regionHDC)
      ? async () => {
          if (areaId) {
            const response = await IntroductionFormApi.getZones({
              areaId,
            });
            setZone(response.data);
          }
        }
      : async (selectedAreaId) => {
          if (selectedAreaId) {
            try {
              const response = await IntroductionFormApi.getZones({
                areaId: selectedAreaId,
              });
              setZone(response.data);
            } catch (error) {
              console.error("Error fetching Zones:", error);
            }
          } else {
            setZone([]);
            setRegion([]);
            setChapter([]);
            setDistrict([]);
          }
        };

  const Regions =
    // isAreaSi && zoneHDC
    (isAreaSi && zoneHDC) ||
    (isHelpDesk && zoneHDC) ||
    (isHelpDeskAdmin && zoneHDC)
      ? async () => {
          if (zoneId) {
            const response = await IntroductionFormApi.getRegions({
              zoneId,
            });
            setRegion(response.data);
          }
        }
      : (isZoneSi && regionHDC) ||
        (isHelpDesk && regionHDC) ||
        (isHelpDeskAdmin && regionHDC)
      ? async () => {
          if (zoneId) {
            const response = await IntroductionFormApi.getRegions({
              zoneId,
            });
            setRegion(response.data);
          }
        }
      : async (selectedZoneId) => {
          if (selectedZoneId) {
            try {
              const response = await IntroductionFormApi.getRegions({
                zoneId: selectedZoneId,
              });
              setRegion(response.data);
            } catch (error) {
              console.error("Error fetching Regions:", error);
            }
          } else {
            setRegion([]);
            setChapter([]);
            setDistrict([]);
          }
        };

  const Chapters =
    (isZoneSi && regionHDC) ||
    (isHelpDesk && regionHDC) ||
    (isHelpDeskAdmin && regionHDC)
      ? async () => {
          if (regionId) {
            const response = await IntroductionFormApi.getChapters({
              regionId,
            });
            setChapter(response.data);
          }
        }
      : async (selectedRegionId) => {
          if (selectedRegionId) {
            try {
              const response = await IntroductionFormApi.getChapters({
                regionId: selectedRegionId,
              });
              setChapter(response.data);
            } catch (error) {
              console.error("Error fetching Chapters:", error);
            }
          } else {
            setChapter([]);
            setDistrict([]);
          }
        };

  const Districts = async (selectedChapterId) => {
    if (selectedChapterId) {
      try {
        const response = await IntroductionFormApi.getDistricts({
          chapterId: selectedChapterId,
        });
        setDistrict(response.data);
      } catch (error) {
        console.error("Error fetching Districts:", error);
      }
    } else {
      setDistrict([]);
    }
  };

  // second row data

  const secondZones =
    (isHelpDesk || isHelpDeskAdmin) && areaHDC
      ? async () => {
          if (areaId) {
            const response = await IntroductionFormApi.getZones({
              areaId,
            });
            setSecondZone(response.data);
          }
        }
      : (isAreaSi && zoneHDC) ||
        (isHelpDesk && zoneHDC) ||
        (isHelpDeskAdmin && zoneHDC)
      ? async () => {
          if (areaId) {
            const response = await IntroductionFormApi.getZones({
              areaId,
            });
            setSecondZone(response.data);
          }
        }
      : (isZoneSi && regionHDC) ||
        (isHelpDesk && regionHDC) ||
        (isHelpDeskAdmin && regionHDC)
      ? async () => {
          if (areaId) {
            const response = await IntroductionFormApi.getZones({
              areaId,
            });
            setSecondZone(response.data);
          }
        }
      : async (selectedAreaId) => {
          if (selectedAreaId) {
            try {
              const response = await IntroductionFormApi.getZones({
                areaId: selectedAreaId,
              });
              setSecondZone(response.data);
            } catch (error) {
              console.error("Error fetching Zones:", error);
            }
          } else {
            setSecondZone([]);
            setSecondRegion([]);
            setSecondChapter([]);
            setSecondDistrict([]);
          }
        };

  const secondRegions =
    (isAreaSi && zoneHDC) ||
    (isHelpDesk && zoneHDC) ||
    (isHelpDeskAdmin && zoneHDC)
      ? async () => {
          if (zoneId) {
            const response = await IntroductionFormApi.getRegions({
              zoneId,
            });
            setSecondRegion(response.data);
          }
        }
      : (isZoneSi && regionHDC) ||
        (isHelpDesk && regionHDC) ||
        (isHelpDeskAdmin && regionHDC)
      ? async () => {
          if (zoneId) {
            const response = await IntroductionFormApi.getRegions({
              zoneId,
            });
            setSecondRegion(response.data);
          }
        }
      : async (selectedZoneId) => {
          if (selectedZoneId) {
            try {
              const response = await IntroductionFormApi.getRegions({
                zoneId: selectedZoneId,
              });
              setSecondRegion(response.data);
            } catch (error) {
              console.error("Error fetching Regions:", error);
            }
          } else {
            setSecondRegion([]);
            setSecondChapter([]);
            setSecondDistrict([]);
          }
        };

  const secondChapters =
    (isZoneSi && regionHDC) ||
    (isHelpDesk && regionHDC) ||
    (isHelpDeskAdmin && regionHDC)
      ? async () => {
          if (regionId) {
            const response = await IntroductionFormApi.getChapters({
              regionId,
            });
            setSecondChapter(response.data);
          }
        }
      : async (selectedRegionId) => {
          if (selectedRegionId) {
            try {
              const response = await IntroductionFormApi.getChapters({
                regionId: selectedRegionId,
              });
              setSecondChapter(response.data);
            } catch (error) {
              console.error("Error fetching Chapters:", error);
            }
          } else {
            setSecondChapter([]);
            setSecondDistrict([]);
          }
        };

  const secondDistricts = async (selectedChapterId) => {
    if (selectedChapterId) {
      try {
        const response = await IntroductionFormApi.getDistricts({
          chapterId: selectedChapterId,
        });
        setSecondDistrict(response.data);
      } catch (error) {
        console.error("Error fetching Districts:", error);
      }
    } else {
      setSecondDistrict([]);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        await Areas();

        if (hdcData?.hdcApplications?.[0]?.areaId) {
          await NewZones();
        }

        if (hdcData?.hdcApplications?.[0]?.zoneId) {
          await NewRegions();
        }

        if (hdcData?.hdcApplications?.[0]?.regionId) {
          await NewChapters();
        }

        if (hdcData?.hdcApplications?.[0]?.chapterId) {
          await NewDistricts();
        }
        setIsLoading(false);
      } catch (error) {
        Sentry.captureException(error);
      }
    };
    const fetchSecondData = async () => {
      try {
        setIsLoadingSecond(true);
        await Areas();

        if (hdcData?.hdcApplications?.[1]?.areaId) {
          await SecondNewZones();
        }

        if (hdcData?.hdcApplications?.[1]?.zoneId) {
          await SecondNewRegions();
        }

        if (hdcData?.hdcApplications?.[1]?.regionId) {
          await SeondNewChapters();
        }

        if (hdcData?.hdcApplications?.[1]?.chapterId) {
          await SecondNewDistricts();
        }
        setIsLoadingSecond(false);
      } catch (error) {
        Sentry.captureException(error);
      }
    };

    if (selectedMember) {
      fetchData();
      fetchSecondData();
    }
  }, [selectedMember, hdcData]);

  useEffect(() => {
    getFetchData(selectedMember);
    NewZones();
    NewRegions();
    NewChapters();
    NewDistricts();
    SecondNewZones();
    SecondNewRegions();
    SeondNewChapters();
    SecondNewDistricts();
  }, [selectedMember]);

  useEffect(() => {
    Areas();
    NewZones();
    NewRegions();
    NewChapters();
    NewDistricts();
    Zones();
    Regions();
  }, []);

  useEffect(() => {
    getFetchData(selectedMember);
    NewZones();
    NewRegions();
    NewChapters();
    NewDistricts();
  }, [selectedMember]);

  useEffect(() => {
    Areas();
    Zones();
    Regions();
    Chapters();
    Districts();
    secondZones();
    secondRegions();
    secondChapters();
    secondDistricts();
  }, []);

  const onSubmit = async (event, formikBag) => {
    event.preventDefault();

    try {
      // if (
      //   formikBag.values[MEMBER_HDC_CREATE.DISTRICT] ===
      //   formikBag.values[MEMBER_HDC_CREATE_SECOND.DISTRICT]
      // ) {
      //   toast.show("Same District in both structures", AlertStatus.ERROR);
      //   return false;
      // }
      const data = {
        structureIds: [
          formikBag.values[MEMBER_HDC_CREATE.DISTRICT],
          formikBag.values[MEMBER_HDC_CREATE_SECOND.DISTRICT],
        ],
      };
      const memberId = selectedMember?.memberId;
      await Member.addHdcRequest(memberId, { data });
      toast.show("Successfully Done", AlertStatus.SUCCESS);

      setTimeout(() => {
        onClose();
      }, 2000);
    } catch (error) {
      Sentry.captureException(error);
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
    }
  };

  console.log(data);
  if (!hdcData) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      {(isLoading || isLoadingSecond) && <Loader />}
      <Formik
        initialValues={{
          // [MEMBER_HDC_CREATE.AREA]:
          // hdcData?.hdcApplications[0]?.areaId || (isHelpDesk && nationalHDC)
          //   ? ""
          //   : areaId,
          // (isHelpDesk && nationalHDC)
          //   ? hdcData?.hdcApplications?.[0]?.areaId : ""
          //   : areaId,
          [MEMBER_HDC_CREATE.AREA]: hdcData?.hdcApplications?.[0]?.areaId
            ? hdcData?.hdcApplications?.[0]?.areaId
            : (isHelpDesk || isHelpDeskAdmin) && nationalHDC
            ? ""
            : areaId,

          [MEMBER_HDC_CREATE.ZONE]: hdcData?.hdcApplications?.[0]?.zoneId
            ? hdcData?.hdcApplications?.[0]?.zoneId
            : (isHelpDesk || isHelpDeskAdmin) && areaHDC
            ? ""
            : zoneId,
          [MEMBER_HDC_CREATE.REGION]: hdcData?.hdcApplications?.[0]?.regionId
            ? hdcData?.hdcApplications?.[0]?.regionId
            : (isAreaSi && zoneHDC) ||
              (isHelpDesk && zoneHDC) ||
              (isHelpDeskAdmin && zoneHDC)
            ? ""
            : regionId,
          [MEMBER_HDC_CREATE.CHAPTER]: hdcData?.hdcApplications?.[0]?.chapterId
            ? hdcData?.hdcApplications?.[0]?.chapterId
            : (isZoneSi && regionHDC) ||
              (isHelpDesk && regionHDC) ||
              (isHelpDeskAdmin && regionHDC)
            ? ""
            : chapterId,
          [MEMBER_HDC_CREATE.DISTRICT]:
            hdcData?.hdcApplications?.[0]?.districtId,

          // Second Structure
          [MEMBER_HDC_CREATE_SECOND.AREA]: hdcData?.hdcApplications?.[1]?.areaId
            ? hdcData?.hdcApplications?.[1]?.areaId
            : (isHelpDesk || isHelpDeskAdmin) && nationalHDC
            ? ""
            : areaId,
          [MEMBER_HDC_CREATE_SECOND.ZONE]: hdcData?.hdcApplications?.[1]?.zoneId
            ? hdcData?.hdcApplications?.[1]?.zoneId
            : (isHelpDesk || isHelpDeskAdmin) && areaHDC
            ? ""
            : zoneId,
          [MEMBER_HDC_CREATE_SECOND.REGION]: hdcData?.hdcApplications?.[1]
            ?.regionId
            ? hdcData?.hdcApplications?.[1]?.regionId
            : (isAreaSi && zoneHDC) ||
              (isHelpDesk && zoneHDC) ||
              (isHelpDeskAdmin && zoneHDC)
            ? ""
            : regionId,
          [MEMBER_HDC_CREATE_SECOND.CHAPTER]: hdcData?.hdcApplications?.[1]
            ?.chapterId
            ? hdcData?.hdcApplications?.[1]?.chapterId
            : (isZoneSi && regionHDC) ||
              (isHelpDesk && regionHDC) ||
              (isHelpDeskAdmin && regionHDC)
            ? ""
            : chapterId,
          [MEMBER_HDC_CREATE_SECOND.DISTRICT]:
            hdcData?.hdcApplications?.[1]?.districtId,
        }}
      >
        {({ values, setFieldValue }) => (
          <form
            onSubmit={(event) => onSubmit(event, { values, setFieldValue })}
          >
            <Box style={{ display: "flex" }}>
              <Typography variant="title2" color="#8c8c8c">
                Honorary District Chief
              </Typography>
              <div
                style={{
                  position: "relative",
                  float: "right",
                  top: "-8px",
                  marginLeft: "auto",
                }}
              >
                <IconButton>
                  <CloseIcon onClick={onClose} />
                </IconButton>
              </div>
            </Box>
            <Box style={{ display: "flex" }}>
              <Box
                style={{
                  width: "100%",
                }}
              >
                <Box style={style.personalDetails}>
                  <Box
                    sx={{
                      display: "flex",
                      gap: "65px",
                    }}
                  >
                    <Typography>Member ID</Typography>
                    <Box>: {memberId || "NA"}</Box>
                  </Box>
                  <Box sx={{ display: "flex", gap: "35px" }}>
                    <Typography>Member Name</Typography>
                    <Box>: {fullName || "NA"}</Box>
                  </Box>
                  <Box sx={{ display: "flex", gap: "20px" }}>
                    <Typography>Mainline Position</Typography>
                    <Box>: {mainlinePosition || "NA"}</Box>
                  </Box>
                </Box>
                <Box style={style.memberOrgBox}>
                  <Typography variant="title3" color="#8c8c8c">
                    Mark Hdc(From Organization Structure: 1)
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: isMobile ? "column" : "row",
                      gap: "20px",
                    }}
                  >
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE.AREA}
                      options={getOptions(area, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE.AREA])}
                      label="Area"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE.AREA, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE.AREA,
                            selectedValue.value
                          );
                        }
                        Zones(selectedValue?.value);

                        setFieldValue(MEMBER_HDC_CREATE.ZONE, "");
                        setFieldValue(MEMBER_HDC_CREATE.REGION, "");
                        setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                        setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        setZone([]);
                        setRegion([]);
                        setChapter([]);
                        setDistrict([]);
                      }}
                      style={{ width: "160px" }}
                      disabled={
                        (isHelpDesk && areaHDC) ||
                        (isHelpDeskAdmin && areaHDC) ||
                        (isHelpDesk && zoneHDC) ||
                        (isHelpDesk && regionHDC) ||
                        (isHelpDeskAdmin && zoneHDC) ||
                        (isHelpDeskAdmin && regionHDC) ||
                        (isAreaSi && zoneHDC) ||
                        (isZoneSi && regionHDC)
                      }
                    />
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE.ZONE}
                      options={getOptions(zone, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE.ZONE])}
                      label="Zone"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE.ZONE, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE.ZONE,
                            selectedValue.value
                          );
                        }
                        Regions(selectedValue?.value);

                        setFieldValue(MEMBER_HDC_CREATE.REGION, "");
                        setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                        setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        setRegion([]);
                        setChapter([]);
                        setDistrict([]);
                      }}
                      style={{ width: "160px" }}
                      disabled={
                        (isHelpDesk && zoneHDC) ||
                        (isHelpDesk && regionHDC) ||
                        (isHelpDeskAdmin && zoneHDC) ||
                        (isHelpDeskAdmin && regionHDC) ||
                        (isAreaSi && zoneHDC) ||
                        (isZoneSi && regionHDC)
                      }
                    />
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE.REGION}
                      options={getOptions(region, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE.REGION])}
                      label="Region"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE.REGION, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE.REGION,
                            selectedValue?.value
                          );
                        }
                        Chapters(selectedValue?.value);

                        setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                        setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        setChapter([]);
                        setDistrict([]);
                      }}
                      style={{ width: "160px" }}
                      disabled={
                        (isHelpDesk && regionHDC) ||
                        (isHelpDeskAdmin && regionHDC) ||
                        (isZoneSi && regionHDC)
                      }
                    />
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE.CHAPTER}
                      options={getOptions(chapter, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE.CHAPTER])}
                      label="Chapter"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE.CHAPTER,
                            selectedValue?.value
                          );
                        }
                        Districts(selectedValue?.value);

                        setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        setDistrict([]);
                      }}
                      style={{ width: "160px" }}
                    />
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE.DISTRICT}
                      options={getOptions(district, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE.DISTRICT])}
                      label="District"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE.DISTRICT,
                            selectedValue?.value
                          );
                        }
                      }}
                      style={{ width: "160px" }}
                    />
                    <Button
                      variant="outlined"
                      style={{
                        width: "80px",
                        height: "30px",
                        marginTop: "5px",
                      }}
                      onClick={() => {
                        // Clear values in the first row dropdowns

                        if (isHelpDesk && areaHDC) {
                          setFieldValue(MEMBER_HDC_CREATE.ZONE, "");
                          setFieldValue(MEMBER_HDC_CREATE.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        } else if (isHelpDeskAdmin && areaHDC) {
                          setFieldValue(MEMBER_HDC_CREATE.ZONE, "");
                          setFieldValue(MEMBER_HDC_CREATE.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        } else if (isAreaSi && zoneHDC) {
                          setFieldValue(MEMBER_HDC_CREATE.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        } else if (isHelpDesk && zoneHDC) {
                          setFieldValue(MEMBER_HDC_CREATE.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        } else if (isHelpDeskAdmin && zoneHDC) {
                          setFieldValue(MEMBER_HDC_CREATE.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        } else if (isZoneSi && regionHDC) {
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        } else if (isHelpDesk && regionHDC) {
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        } else if (isHelpDeskAdmin && regionHDC) {
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        } else {
                          setFieldValue(MEMBER_HDC_CREATE.AREA, "");
                          setFieldValue(MEMBER_HDC_CREATE.ZONE, "");
                          setFieldValue(MEMBER_HDC_CREATE.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        }
                      }}
                      label="Clear"
                    />
                  </Box>

                  {/* Second structure Row */}
                  <Typography variant="title3" color="#8c8c8c">
                    Mark Hdc(From Organization Structure: 2)
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: isMobile ? "column" : "row",
                      gap: "20px",
                    }}
                  >
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE_SECOND.AREA}
                      options={getOptions(area, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE_SECOND.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE_SECOND.AREA])}
                      label="Area"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.AREA, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE_SECOND.AREA,
                            selectedValue?.value
                          );
                        }
                        secondZones(selectedValue?.value);

                        setFieldValue(MEMBER_HDC_CREATE_SECOND.ZONE, "");
                        setFieldValue(MEMBER_HDC_CREATE_SECOND.REGION, "");
                        setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                        setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        setSecondZone([]);
                        setSecondRegion([]);
                        setSecondChapter([]);
                        setSecondDistrict([]);
                      }}
                      style={{ width: "160px" }}
                      disabled={
                        (isHelpDesk && areaHDC) ||
                        (isHelpDeskAdmin && areaHDC) ||
                        (isAreaSi && zoneHDC) ||
                        (isHelpDesk && zoneHDC) ||
                        (isHelpDeskAdmin && zoneHDC) ||
                        (isHelpDesk && regionHDC) ||
                        (isHelpDeskAdmin && regionHDC) ||
                        (isZoneSi && regionHDC)
                      }
                    />
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE_SECOND.ZONE}
                      options={getOptions(secondZone, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE_SECOND.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE_SECOND.ZONE])}
                      label="Zone"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.ZONE, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE_SECOND.ZONE,
                            selectedValue?.value
                          );
                        }
                        secondRegions(selectedValue?.value);

                        setFieldValue(MEMBER_HDC_CREATE_SECOND.REGION, "");
                        setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                        setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        setSecondRegion([]);
                        setSecondChapter([]);
                        setSecondDistrict([]);
                      }}
                      style={{ width: "160px" }}
                      disabled={
                        (isAreaSi && zoneHDC) ||
                        (isZoneSi && regionHDC) ||
                        (isHelpDesk && zoneHDC) ||
                        (isHelpDeskAdmin && zoneHDC) ||
                        (isHelpDesk && regionHDC) ||
                        (isHelpDeskAdmin && regionHDC)
                      }
                    />
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE_SECOND.REGION}
                      options={getOptions(secondRegion, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE_SECOND.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE_SECOND.REGION])}
                      label="Region"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.REGION, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE_SECOND.REGION,
                            selectedValue?.value
                          );
                        }
                        secondChapters(selectedValue?.value);

                        setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                        setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        setSecondChapter([]);
                        setSecondDistrict([]);
                      }}
                      style={{ width: "160px" }}
                      disabled={
                        (isZoneSi && regionHDC) ||
                        (isHelpDesk && regionHDC) ||
                        (isHelpDeskAdmin && regionHDC)
                      }
                    />
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE_SECOND.CHAPTER}
                      options={getOptions(secondChapter, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE_SECOND.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE_SECOND.CHAPTER])}
                      label="Chapter"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE_SECOND.CHAPTER,
                            selectedValue?.value
                          );
                        }
                        secondDistricts(selectedValue?.value);

                        setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        setSecondDistrict([]);
                      }}
                      style={{ width: "160px" }}
                    />
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE_SECOND.DISTRICT}
                      options={getOptions(secondDistrict, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE_2.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE_SECOND.DISTRICT])}
                      label="District"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE_SECOND.DISTRICT,
                            selectedValue?.value
                          );
                        }
                      }}
                      style={{ width: "160px" }}
                    />
                    <Button
                      variant="outlined"
                      style={{
                        width: "80px",
                        height: "30px",
                        marginTop: "5px",
                      }}
                      onClick={() => {
                        // Clear values in the second row dropdowns
                        if (isHelpDesk && areaHDC) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.ZONE, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        } else if (isHelpDeskAdmin && areaHDC) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.ZONE, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        } else if (isAreaSi && zoneHDC) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        } else if (isHelpDesk && zoneHDC) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        } else if (isHelpDeskAdmin && zoneHDC) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        } else if (isZoneSi && regionHDC) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        } else if (isHelpDesk && regionHDC) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        } else if (isHelpDeskAdmin && regionHDC) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        } else {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.AREA, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.ZONE, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        }
                      }}
                      label="Clear"
                    />
                  </Box>
                </Box>
                {/* <Typography
                  as="span"
                  style={{
                    color: "#183053",
                    fontSize: "16px",
                    fontWeight: "500",
                    cursor: "pointer",
                    display: !showSecondRow ? "block" : "none", // Show & Hide "Add Another"
                  }}
                  onClick={() => setShowSecondRow(!showSecondRow)}
                >
                  Add Another
                </Typography> */}
                {/* second row  */}
              </Box>
            </Box>
            <Box style={style.buttonStyle}>
              <Button
                style={CommonStyles.buttonStyle}
                variant="outlined"
                onClick={onClose}
                label="CANCEL"
              />
              <Button
                style={CommonStyles.buttonStyle}
                variant="contained"
                type="submit"
                label="SAVE"
              />
            </Box>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default HDCModal;
